import React from 'react';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <h2>Medicinal Mushrooms from the Kootenays</h2>
        <div className="about-text">
          <p>
            At MindLever, we harness the remarkable power of functional mushrooms from the pristine
            forests of British Columbia. Our mission is to provide concentrated mushroom extract powder
            supplements that honor traditional wisdom while delivering maximum bioavailability through
            modern extraction techniques.
          </p>
          <p>
            From Lion's Mane for cognitive support to Reishi for calm and immunity, every product features
            sustainably wildcrafted medicinal mushrooms. We believe in transparency, quality, and the
            profound healing potential of these ancient organisms.
          </p>
        </div>
        <div className="about-image">
          <img
            src="/stock/pexels-planka-28700281.jpg"
            alt="Medicinal Mushrooms Natural Health"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
